/**
 * Integration Icons
 * Custom SVG icons for third-party integrations, sourced from n8n's MIT-licensed repository.
 * https://github.com/n8n-io/n8n
 */

import React from 'react';

interface IconProps {
  size?: number | string;
  className?: string;
  color?: string;
}

// Asana Icon (official from n8n - gradient 3-circle logo)
export const AsanaIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 60 60"
    className={className}
  >
    <defs>
      <radialGradient
        id="asana-grad"
        cx="50%"
        cy="55%"
        r="72.507%"
        fx="50%"
        fy="55%"
        gradientTransform="matrix(.92404 0 0 1 .038 0)"
      >
        <stop offset="0%" stopColor="#FFB900" />
        <stop offset="60%" stopColor="#F95D8F" />
        <stop offset="99.91%" stopColor="#F95353" />
      </radialGradient>
    </defs>
    <path
      fill="url(#asana-grad)"
      fillRule="evenodd"
      d="M45.594 28.5c-6.994.003-12.664 5.673-12.667 12.667.003 6.995 5.673 12.664 12.667 12.668 6.995-.004 12.664-5.673 12.667-12.668-.003-6.994-5.672-12.664-12.667-12.667m-32.927.001C5.673 28.505.003 34.174 0 41.17c.003 6.994 5.673 12.664 12.667 12.667 6.995-.003 12.664-5.673 12.668-12.667-.004-6.995-5.673-12.664-12.668-12.668zM41.79 12.667c-.002 6.995-5.671 12.665-12.666 12.67-6.995-.004-12.664-5.674-12.667-12.67C16.46 5.673 22.13.003 29.123 0c6.994.004 12.663 5.673 12.666 12.667z"
      transform="translate(.732 2.732)"
    />
  </svg>
);

// Map of icon names to components
export const integrationIconsMap: Record<string, React.FC<IconProps>> = {
  'asana': AsanaIcon,
};

// Get integration icon component by name
export function getIntegrationIcon(name: string): React.FC<IconProps> | undefined {
  return integrationIconsMap[name];
}

// Check if an integration icon exists
export function hasIntegrationIcon(name: string): boolean {
  return name in integrationIconsMap;
}
